import PropTypes from "prop-types"

const ItemNamePercentageCountShape = {
  count: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  itemName: PropTypes.string.isRequired,
}
export default ItemNamePercentageCountShape



// WEBPACK FOOTER //
// ./src/state/shapes/ItemNamePercentageCountShape.js